import { useCartStore } from '@/shared/store/cartStore'

const cartStore = useCartStore()

export default cartStore

export type CartState = ReturnType<typeof cartStore['state']>
